// extracted by mini-css-extract-plugin
export default {"containerAllCard":"Dashboard_containerAllCard__JB3lC"};